import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';
import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';

export function canViewPrivateEvents(calendarEntry: CalendarEntry): boolean {
    return (calendarEntry as LocalCalendarEntry).CanViewPrivateItems;
}
